module.exports = __webpack_public_path__ + "static/media/effect-03.4b326d71.png";